import { InventoryFacility } from '@/models/inventory';
import { Order, OrderComment, OrderDocument, OrderReturn, OrderSent, PaymentMethods } from '@/models/order';

export interface OrderState {
  orderComments: OrderComment[];
  orderDocuments: OrderDocument[];
  orders: Order[];
  ordersSent: OrderSent[];
  returns: OrderReturn[];
  isLoadingOrderReturns: boolean;
  isLoadingOrders?: boolean;
  paymentMethods: PaymentMethods[];
  selectedFacility?: InventoryFacility;
}

export const state: OrderState = {
  orderComments: [],
  orderDocuments: [],
  orders: [], // TODO: rename to `ordersReceived`
  ordersSent: [],
  returns: [],
  isLoadingOrderReturns: false,
  isLoadingOrders: false, // TODO: rename to isLoadingOrdersReceived
  paymentMethods: [],
  selectedFacility: undefined,
};
